module.exports = __webpack_public_path__ + "static/media/2.10_preview.7c568b6a.png";